import { SecurityService } from '../../../services/security';
import { RaporApiBase } from '../../core/ApiBase';

export default class SirketBazliYurtDisiTasinmazRapor extends RaporApiBase {
  constructor(id: number, sirketAdi: string) {
    super();
    this._MethodUrl = SecurityService.URLSafeParams([
      { name: 'RaporTuru', value: 'YurtDisiTasinmazSirketBazliRapor' },
      { name: 'ID', value: id },
      { name: 'SirketAdi', value: sirketAdi }
    ]);
  }
}
